"use client";
import Image from "next/image";
import StatusTracker from "../_components/statusTracker";
import { useEffect, useState } from "react";
import { getResumeRevamp } from "api/resume-writing/getResumeRevamp";
import { Status } from "../_components/constants";
import Link from "next/link";
import { ArrowRightIcon } from "@heroicons/react/24/outline";

const ResumeWritingStatus = () => {
  const [status, setStatus] = useState<Status>(Status.notSubscribed);
  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await getResumeRevamp();
        setStatus(response.status);
      } catch (error) {
        console.error(error);
      }
    };
    fetchStatus();
  }, []);
  return (
    <main className="flex h-screen w-screen flex-col items-center justify-center gap-5 bg-white">
      {status === Status.notSubscribed ? (
        <>
          <div className="flex flex-col items-center text-center">
            <Image
              src="/assets/resume-writing/resume-writing-status.png"
              alt="Resume Writing Service"
              width={200}
              height={250}
              className="mb-5"
            />
            <h2 className="text-xl font-semibold text-gray-700">
              You are not subscribed to Resumemate's Resume Writing Service
            </h2>
            <p className="mt-2 text-sm text-gray-500">
              Subscribe to our service to track the status of your resume
              writing progress and receive expert assistance!
            </p>
          </div>
        </>
      ) : (
        <div className="flex space-x-10">
          <Image
            src="/assets/resume-writing/resume-writing-status.png"
            alt="Resume Writing Status"
            width={245}
            height={306}
            className="hidden lg:block"
          />
          <StatusTracker currentStage={status} />
        </div>
      )}
      <div className="mt-10 flex space-x-1 text-xs md:space-x-7 md:text-base">
        <Link
          href={`/resume-writing${
            status === Status.notSubscribed ? "#plans" : ""
          }`}
          className="inline-flex items-center gap-1 rounded-3xl bg-[#7A5CFA] px-4 py-2 font-medium text-white md:gap-3 md:px-8 md:py-3"
        >
          {status === Status.notSubscribed ? "Subscribe Now" : "Back to Home"}{" "}
          <ArrowRightIcon className="h-5 w-5" />
        </Link>
        <Link
          href="https://wa.me/918618147607"
          className="inline-flex items-center gap-1 rounded-3xl border border-[#7A5CFA] bg-white px-4 py-2 font-medium text-[#7A5CFA] drop-shadow-md md:gap-2 md:px-8 md:py-3"
        >
          Chat on Whatsapp{" "}
          <Image
            alt="Whatsapp Icon"
            src="/assets/whatsapp.svg"
            width={28}
            height={28}
          />
        </Link>
      </div>
    </main>
  );
};

export default ResumeWritingStatus;
